import { PromoNewComponents } from '@affiliate-cabinet/types'

import { promoPlatformsEntityTranslationKeys } from './translations/promoPlatformsEntityTranslationKeys'

const PROMO_BANNER_FILE_FORMATS_LIST: { translationKey: string; value: '' | Exclude<PromoNewComponents['schemas']['FileFormat'], null> }[] = [
  { translationKey: promoPlatformsEntityTranslationKeys.promoMediaTypeImage, value: 'image' },
  { translationKey: promoPlatformsEntityTranslationKeys.promoMediaTypeHTML, value: 'html5' },
  { translationKey: promoPlatformsEntityTranslationKeys.promoMediaTypeGIF, value: 'gif' },
]

export const promoBannersFileFormatsEntity = {
  PROMO_BANNER_FILE_FORMATS_LIST,
}
